import React from 'react';

function ErrorPage() {
  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h2 style={{ color: 'red', marginBottom: '12px' }}>Unexpected Error</h2>
      <p>Something went wrong. Please return to the home page and try again.</p>
      <a href="/" style={{ color: '#2186EB', textDecoration: 'underline' }}>
        Go Home
      </a>
    </div>
  );
}

export default ErrorPage;
